import React, {FC, ReactElement} from "react";
import {Grid} from "@mui/material";
import {observer} from "mobx-react";
import {AlertColor} from "@mui/material/Alert/Alert";
import {FormikProps} from "formik/dist/types";
import {GetCompanySettingsDto} from "../../../model/company/GetCompanySettingsDto";
import TextFieldWithValidation from "../../../components/input/TextFieldWithValidation";

export const AiSettingsDetailsCard: FC<{
    formik: FormikProps<GetCompanySettingsDto>
    showSnackBar: (messageType: AlertColor, messageText: string) => void
}> = observer(({formik}): ReactElement => {
    const aiData = formik.values.aiData

    return <>
        <Grid container alignItems="center" spacing={2}>
            <Grid item container xs={6}>
                <Grid item xs={12}>
                    <TextFieldWithValidation
                            name="aiData.purchaseInvoiceRecognitionPrompt"
                            label="Purchase invoice recognition prompt"
                            value={aiData.purchaseInvoiceRecognitionPrompt}
                            fullWidth={true}
                            multiline
                            minRows={3}
                            maxRows={6}
                            onChange={formik.handleChange}
                    />
                </Grid>
            </Grid>
        </Grid>
    </>
});